import type {
  BackendMatch, BackendPeriod, BackendTimer,
  TransformedMatch, TransformedPeriod, TransformedTimerEntity,
} from './types';

// ---

export const transformMatch = (entry: BackendMatch): TransformedMatch => ({
  id: entry.id,
  sportId: entry.sportId,
  matchClasses: entry.matchClasses,
  modelType: entry.modelType,
  tournamentUnionId: entry.tournamentUnionId,
  tournamentId: entry.tournamentId,
  tournamentStageId: entry.tournamentStageId,
  slotType: entry.slotKey,
  type: entry.type,
  isOpen: entry.isOpen,
  name: entry.name,
  betsCount: entry.betsCount,
  state: entry.state,
  attributes: entry.attributes,
  startDate: entry.startDate,
  scores: entry.scores,
  status: entry.status,
  removedStakes: 'removedStakes' in entry ? entry.removedStakes : undefined,
  removedBets: 'removedBets' in entry ? entry.removedBets : undefined,
  timer: entry.timer,
  periods: entry.periods,
  objects: entry.objects,
  stakes: entry.stakes,
  bets: entry.bets,
  liveTracker: entry.liveTracker,
  matchComment: entry.matchComment,
  globalPriority: entry.globalPriority,
});

export const transformPeriod = (entry: BackendPeriod): TransformedPeriod => ({
  number: entry.number,
  finished: entry.finished,
});

export const transformTimer = (entry: BackendTimer): TransformedTimerEntity => ({
  started: entry.started,
  reverse: entry.reverse,
  gameTime: entry.gameTime,
  timestamp: entry.timestamp,
});
